/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as DocumentCollectionsIndexRouteImport } from './routes/document-collections/index'
import { Route as AutomationsIndexRouteImport } from './routes/automations/index'
import { Route as AdministrationIndexRouteImport } from './routes/administration/index'
import { Route as TeamMembersRouteImport } from './routes/team/members'
import { Route as SettingsWebhooksRouteImport } from './routes/settings/webhooks'
import { Route as SettingsProfileRouteImport } from './routes/settings/profile'
import { Route as SettingsPaymentsRouteImport } from './routes/settings/payments'
import { Route as SettingsMcpRouteImport } from './routes/settings/mcp'
import { Route as SettingsLegalRouteImport } from './routes/settings/legal'
import { Route as SettingsGeneralRouteImport } from './routes/settings/general'
import { Route as SettingsCommunicationsRouteImport } from './routes/settings/communications'
import { Route as SettingsAiRouteImport } from './routes/settings/ai'
import { Route as Settings1cRouteImport } from './routes/settings/1c'
import { Route as DocumentIdRouteImport } from './routes/document/$id'
import { Route as DemoStorybookRouteImport } from './routes/demo/storybook'
import { Route as CommunicationsSettingsRouteImport } from './routes/communications/settings'
import { Route as CommunicationsContactsRouteImport } from './routes/communications/contacts'
import { Route as AutomationsNewRouteImport } from './routes/automations/new'
import { Route as AdministrationJobsRouteImport } from './routes/administration/jobs'
import { Route as AdministrationFeatureTogglesRouteImport } from './routes/administration/feature-toggles'
import { Route as SettingsStateModelsIndexRouteImport } from './routes/settings/state-models_/index'
import { Route as DocumentCollectionIdIndexRouteImport } from './routes/document-collection_/$id/index'
import { Route as AutomationsIdIndexRouteImport } from './routes/automations/$id/index'
import { Route as SettingsStateModelsNewRouteImport } from './routes/settings/state-models_/new'
import { Route as DocumentCollectionIdDocumentFieldsRouteImport } from './routes/document-collection_/$id/document-fields'
import { Route as AutomationsIdEditRouteImport } from './routes/automations/$id/edit'
import { Route as SettingsStateModelsIdEditRouteImport } from './routes/settings/state-models_/$id/edit'

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentCollectionsIndexRoute =
  DocumentCollectionsIndexRouteImport.update({
    id: '/document-collections/',
    path: '/document-collections/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AutomationsIndexRoute = AutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationIndexRoute = AdministrationIndexRouteImport.update({
  id: '/administration/',
  path: '/administration/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamMembersRoute = TeamMembersRouteImport.update({
  id: '/team/members',
  path: '/team/members',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWebhooksRoute = SettingsWebhooksRouteImport.update({
  id: '/settings/webhooks',
  path: '/settings/webhooks',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsPaymentsRoute = SettingsPaymentsRouteImport.update({
  id: '/settings/payments',
  path: '/settings/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMcpRoute = SettingsMcpRouteImport.update({
  id: '/settings/mcp',
  path: '/settings/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLegalRoute = SettingsLegalRouteImport.update({
  id: '/settings/legal',
  path: '/settings/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: '/settings/general',
  path: '/settings/general',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsCommunicationsRoute = SettingsCommunicationsRouteImport.update({
  id: '/settings/communications',
  path: '/settings/communications',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsAiRoute = SettingsAiRouteImport.update({
  id: '/settings/ai',
  path: '/settings/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const Settings1cRoute = Settings1cRouteImport.update({
  id: '/settings/1c',
  path: '/settings/1c',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentIdRoute = DocumentIdRouteImport.update({
  id: '/document/$id',
  path: '/document/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoStorybookRoute = DemoStorybookRouteImport.update({
  id: '/demo/storybook',
  path: '/demo/storybook',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsSettingsRoute = CommunicationsSettingsRouteImport.update({
  id: '/communications/settings',
  path: '/communications/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsContactsRoute = CommunicationsContactsRouteImport.update({
  id: '/communications/contacts',
  path: '/communications/contacts',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationsNewRoute = AutomationsNewRouteImport.update({
  id: '/automations/new',
  path: '/automations/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationJobsRoute = AdministrationJobsRouteImport.update({
  id: '/administration/jobs',
  path: '/administration/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationFeatureTogglesRoute =
  AdministrationFeatureTogglesRouteImport.update({
    id: '/administration/feature-toggles',
    path: '/administration/feature-toggles',
    getParentRoute: () => rootRouteImport,
  } as any)
const SettingsStateModelsIndexRoute =
  SettingsStateModelsIndexRouteImport.update({
    id: '/settings/state-models_/',
    path: '/settings/state-models/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentCollectionIdIndexRoute =
  DocumentCollectionIdIndexRouteImport.update({
    id: '/document-collection_/$id/',
    path: '/document-collection/$id/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AutomationsIdIndexRoute = AutomationsIdIndexRouteImport.update({
  id: '/automations/$id/',
  path: '/automations/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsStateModelsNewRoute = SettingsStateModelsNewRouteImport.update({
  id: '/settings/state-models_/new',
  path: '/settings/state-models/new',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentCollectionIdDocumentFieldsRoute =
  DocumentCollectionIdDocumentFieldsRouteImport.update({
    id: '/document-collection_/$id/document-fields',
    path: '/document-collection/$id/document-fields',
    getParentRoute: () => rootRouteImport,
  } as any)
const AutomationsIdEditRoute = AutomationsIdEditRouteImport.update({
  id: '/automations/$id/edit',
  path: '/automations/$id/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsStateModelsIdEditRoute =
  SettingsStateModelsIdEditRouteImport.update({
    id: '/settings/state-models_/$id/edit',
    path: '/settings/state-models/$id/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/administration/feature-toggles': typeof AdministrationFeatureTogglesRoute
  '/administration/jobs': typeof AdministrationJobsRoute
  '/automations/new': typeof AutomationsNewRoute
  '/communications/contacts': typeof CommunicationsContactsRoute
  '/communications/settings': typeof CommunicationsSettingsRoute
  '/demo/storybook': typeof DemoStorybookRoute
  '/document/$id': typeof DocumentIdRoute
  '/settings/1c': typeof Settings1cRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/communications': typeof SettingsCommunicationsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/legal': typeof SettingsLegalRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
  '/team/members': typeof TeamMembersRoute
  '/administration/': typeof AdministrationIndexRoute
  '/automations/': typeof AutomationsIndexRoute
  '/document-collections/': typeof DocumentCollectionsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/automations/$id/edit': typeof AutomationsIdEditRoute
  '/document-collection/$id/document-fields': typeof DocumentCollectionIdDocumentFieldsRoute
  '/settings/state-models/new': typeof SettingsStateModelsNewRoute
  '/automations/$id/': typeof AutomationsIdIndexRoute
  '/document-collection/$id/': typeof DocumentCollectionIdIndexRoute
  '/settings/state-models/': typeof SettingsStateModelsIndexRoute
  '/settings/state-models/$id/edit': typeof SettingsStateModelsIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/administration/feature-toggles': typeof AdministrationFeatureTogglesRoute
  '/administration/jobs': typeof AdministrationJobsRoute
  '/automations/new': typeof AutomationsNewRoute
  '/communications/contacts': typeof CommunicationsContactsRoute
  '/communications/settings': typeof CommunicationsSettingsRoute
  '/demo/storybook': typeof DemoStorybookRoute
  '/document/$id': typeof DocumentIdRoute
  '/settings/1c': typeof Settings1cRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/communications': typeof SettingsCommunicationsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/legal': typeof SettingsLegalRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
  '/team/members': typeof TeamMembersRoute
  '/administration': typeof AdministrationIndexRoute
  '/automations': typeof AutomationsIndexRoute
  '/document-collections': typeof DocumentCollectionsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/automations/$id/edit': typeof AutomationsIdEditRoute
  '/document-collection/$id/document-fields': typeof DocumentCollectionIdDocumentFieldsRoute
  '/settings/state-models/new': typeof SettingsStateModelsNewRoute
  '/automations/$id': typeof AutomationsIdIndexRoute
  '/document-collection/$id': typeof DocumentCollectionIdIndexRoute
  '/settings/state-models': typeof SettingsStateModelsIndexRoute
  '/settings/state-models/$id/edit': typeof SettingsStateModelsIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/administration/feature-toggles': typeof AdministrationFeatureTogglesRoute
  '/administration/jobs': typeof AdministrationJobsRoute
  '/automations/new': typeof AutomationsNewRoute
  '/communications/contacts': typeof CommunicationsContactsRoute
  '/communications/settings': typeof CommunicationsSettingsRoute
  '/demo/storybook': typeof DemoStorybookRoute
  '/document/$id': typeof DocumentIdRoute
  '/settings/1c': typeof Settings1cRoute
  '/settings/ai': typeof SettingsAiRoute
  '/settings/communications': typeof SettingsCommunicationsRoute
  '/settings/general': typeof SettingsGeneralRoute
  '/settings/legal': typeof SettingsLegalRoute
  '/settings/mcp': typeof SettingsMcpRoute
  '/settings/payments': typeof SettingsPaymentsRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/settings/webhooks': typeof SettingsWebhooksRoute
  '/team/members': typeof TeamMembersRoute
  '/administration/': typeof AdministrationIndexRoute
  '/automations/': typeof AutomationsIndexRoute
  '/document-collections/': typeof DocumentCollectionsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/automations/$id/edit': typeof AutomationsIdEditRoute
  '/document-collection_/$id/document-fields': typeof DocumentCollectionIdDocumentFieldsRoute
  '/settings/state-models_/new': typeof SettingsStateModelsNewRoute
  '/automations/$id/': typeof AutomationsIdIndexRoute
  '/document-collection_/$id/': typeof DocumentCollectionIdIndexRoute
  '/settings/state-models_/': typeof SettingsStateModelsIndexRoute
  '/settings/state-models_/$id/edit': typeof SettingsStateModelsIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/login'
    | '/logout'
    | '/administration/feature-toggles'
    | '/administration/jobs'
    | '/automations/new'
    | '/communications/contacts'
    | '/communications/settings'
    | '/demo/storybook'
    | '/document/$id'
    | '/settings/1c'
    | '/settings/ai'
    | '/settings/communications'
    | '/settings/general'
    | '/settings/legal'
    | '/settings/mcp'
    | '/settings/payments'
    | '/settings/profile'
    | '/settings/webhooks'
    | '/team/members'
    | '/administration/'
    | '/automations/'
    | '/document-collections/'
    | '/settings/'
    | '/automations/$id/edit'
    | '/document-collection/$id/document-fields'
    | '/settings/state-models/new'
    | '/automations/$id/'
    | '/document-collection/$id/'
    | '/settings/state-models/'
    | '/settings/state-models/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/login'
    | '/logout'
    | '/administration/feature-toggles'
    | '/administration/jobs'
    | '/automations/new'
    | '/communications/contacts'
    | '/communications/settings'
    | '/demo/storybook'
    | '/document/$id'
    | '/settings/1c'
    | '/settings/ai'
    | '/settings/communications'
    | '/settings/general'
    | '/settings/legal'
    | '/settings/mcp'
    | '/settings/payments'
    | '/settings/profile'
    | '/settings/webhooks'
    | '/team/members'
    | '/administration'
    | '/automations'
    | '/document-collections'
    | '/settings'
    | '/automations/$id/edit'
    | '/document-collection/$id/document-fields'
    | '/settings/state-models/new'
    | '/automations/$id'
    | '/document-collection/$id'
    | '/settings/state-models'
    | '/settings/state-models/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/login'
    | '/logout'
    | '/administration/feature-toggles'
    | '/administration/jobs'
    | '/automations/new'
    | '/communications/contacts'
    | '/communications/settings'
    | '/demo/storybook'
    | '/document/$id'
    | '/settings/1c'
    | '/settings/ai'
    | '/settings/communications'
    | '/settings/general'
    | '/settings/legal'
    | '/settings/mcp'
    | '/settings/payments'
    | '/settings/profile'
    | '/settings/webhooks'
    | '/team/members'
    | '/administration/'
    | '/automations/'
    | '/document-collections/'
    | '/settings/'
    | '/automations/$id/edit'
    | '/document-collection_/$id/document-fields'
    | '/settings/state-models_/new'
    | '/automations/$id/'
    | '/document-collection_/$id/'
    | '/settings/state-models_/'
    | '/settings/state-models_/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  AdministrationFeatureTogglesRoute: typeof AdministrationFeatureTogglesRoute
  AdministrationJobsRoute: typeof AdministrationJobsRoute
  AutomationsNewRoute: typeof AutomationsNewRoute
  CommunicationsContactsRoute: typeof CommunicationsContactsRoute
  CommunicationsSettingsRoute: typeof CommunicationsSettingsRoute
  DemoStorybookRoute: typeof DemoStorybookRoute
  DocumentIdRoute: typeof DocumentIdRoute
  Settings1cRoute: typeof Settings1cRoute
  SettingsAiRoute: typeof SettingsAiRoute
  SettingsCommunicationsRoute: typeof SettingsCommunicationsRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsLegalRoute: typeof SettingsLegalRoute
  SettingsMcpRoute: typeof SettingsMcpRoute
  SettingsPaymentsRoute: typeof SettingsPaymentsRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SettingsWebhooksRoute: typeof SettingsWebhooksRoute
  TeamMembersRoute: typeof TeamMembersRoute
  AdministrationIndexRoute: typeof AdministrationIndexRoute
  AutomationsIndexRoute: typeof AutomationsIndexRoute
  DocumentCollectionsIndexRoute: typeof DocumentCollectionsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  AutomationsIdEditRoute: typeof AutomationsIdEditRoute
  DocumentCollectionIdDocumentFieldsRoute: typeof DocumentCollectionIdDocumentFieldsRoute
  SettingsStateModelsNewRoute: typeof SettingsStateModelsNewRoute
  AutomationsIdIndexRoute: typeof AutomationsIdIndexRoute
  DocumentCollectionIdIndexRoute: typeof DocumentCollectionIdIndexRoute
  SettingsStateModelsIndexRoute: typeof SettingsStateModelsIndexRoute
  SettingsStateModelsIdEditRoute: typeof SettingsStateModelsIdEditRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document-collections/': {
      id: '/document-collections/'
      path: '/document-collections'
      fullPath: '/document-collections/'
      preLoaderRoute: typeof DocumentCollectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/': {
      id: '/automations/'
      path: '/automations'
      fullPath: '/automations/'
      preLoaderRoute: typeof AutomationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/': {
      id: '/administration/'
      path: '/administration'
      fullPath: '/administration/'
      preLoaderRoute: typeof AdministrationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/members': {
      id: '/team/members'
      path: '/team/members'
      fullPath: '/team/members'
      preLoaderRoute: typeof TeamMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/webhooks': {
      id: '/settings/webhooks'
      path: '/settings/webhooks'
      fullPath: '/settings/webhooks'
      preLoaderRoute: typeof SettingsWebhooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/payments': {
      id: '/settings/payments'
      path: '/settings/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof SettingsPaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/mcp': {
      id: '/settings/mcp'
      path: '/settings/mcp'
      fullPath: '/settings/mcp'
      preLoaderRoute: typeof SettingsMcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/legal': {
      id: '/settings/legal'
      path: '/settings/legal'
      fullPath: '/settings/legal'
      preLoaderRoute: typeof SettingsLegalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/general': {
      id: '/settings/general'
      path: '/settings/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/communications': {
      id: '/settings/communications'
      path: '/settings/communications'
      fullPath: '/settings/communications'
      preLoaderRoute: typeof SettingsCommunicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/ai': {
      id: '/settings/ai'
      path: '/settings/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof SettingsAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/1c': {
      id: '/settings/1c'
      path: '/settings/1c'
      fullPath: '/settings/1c'
      preLoaderRoute: typeof Settings1cRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document/$id': {
      id: '/document/$id'
      path: '/document/$id'
      fullPath: '/document/$id'
      preLoaderRoute: typeof DocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/storybook': {
      id: '/demo/storybook'
      path: '/demo/storybook'
      fullPath: '/demo/storybook'
      preLoaderRoute: typeof DemoStorybookRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/settings': {
      id: '/communications/settings'
      path: '/communications/settings'
      fullPath: '/communications/settings'
      preLoaderRoute: typeof CommunicationsSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/contacts': {
      id: '/communications/contacts'
      path: '/communications/contacts'
      fullPath: '/communications/contacts'
      preLoaderRoute: typeof CommunicationsContactsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/new': {
      id: '/automations/new'
      path: '/automations/new'
      fullPath: '/automations/new'
      preLoaderRoute: typeof AutomationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/jobs': {
      id: '/administration/jobs'
      path: '/administration/jobs'
      fullPath: '/administration/jobs'
      preLoaderRoute: typeof AdministrationJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration/feature-toggles': {
      id: '/administration/feature-toggles'
      path: '/administration/feature-toggles'
      fullPath: '/administration/feature-toggles'
      preLoaderRoute: typeof AdministrationFeatureTogglesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/state-models_/': {
      id: '/settings/state-models_/'
      path: '/settings/state-models'
      fullPath: '/settings/state-models/'
      preLoaderRoute: typeof SettingsStateModelsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document-collection_/$id/': {
      id: '/document-collection_/$id/'
      path: '/document-collection/$id'
      fullPath: '/document-collection/$id/'
      preLoaderRoute: typeof DocumentCollectionIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/$id/': {
      id: '/automations/$id/'
      path: '/automations/$id'
      fullPath: '/automations/$id/'
      preLoaderRoute: typeof AutomationsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/state-models_/new': {
      id: '/settings/state-models_/new'
      path: '/settings/state-models/new'
      fullPath: '/settings/state-models/new'
      preLoaderRoute: typeof SettingsStateModelsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document-collection_/$id/document-fields': {
      id: '/document-collection_/$id/document-fields'
      path: '/document-collection/$id/document-fields'
      fullPath: '/document-collection/$id/document-fields'
      preLoaderRoute: typeof DocumentCollectionIdDocumentFieldsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/$id/edit': {
      id: '/automations/$id/edit'
      path: '/automations/$id/edit'
      fullPath: '/automations/$id/edit'
      preLoaderRoute: typeof AutomationsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/state-models_/$id/edit': {
      id: '/settings/state-models_/$id/edit'
      path: '/settings/state-models/$id/edit'
      fullPath: '/settings/state-models/$id/edit'
      preLoaderRoute: typeof SettingsStateModelsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  AdministrationFeatureTogglesRoute: AdministrationFeatureTogglesRoute,
  AdministrationJobsRoute: AdministrationJobsRoute,
  AutomationsNewRoute: AutomationsNewRoute,
  CommunicationsContactsRoute: CommunicationsContactsRoute,
  CommunicationsSettingsRoute: CommunicationsSettingsRoute,
  DemoStorybookRoute: DemoStorybookRoute,
  DocumentIdRoute: DocumentIdRoute,
  Settings1cRoute: Settings1cRoute,
  SettingsAiRoute: SettingsAiRoute,
  SettingsCommunicationsRoute: SettingsCommunicationsRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsLegalRoute: SettingsLegalRoute,
  SettingsMcpRoute: SettingsMcpRoute,
  SettingsPaymentsRoute: SettingsPaymentsRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SettingsWebhooksRoute: SettingsWebhooksRoute,
  TeamMembersRoute: TeamMembersRoute,
  AdministrationIndexRoute: AdministrationIndexRoute,
  AutomationsIndexRoute: AutomationsIndexRoute,
  DocumentCollectionsIndexRoute: DocumentCollectionsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  AutomationsIdEditRoute: AutomationsIdEditRoute,
  DocumentCollectionIdDocumentFieldsRoute:
    DocumentCollectionIdDocumentFieldsRoute,
  SettingsStateModelsNewRoute: SettingsStateModelsNewRoute,
  AutomationsIdIndexRoute: AutomationsIdIndexRoute,
  DocumentCollectionIdIndexRoute: DocumentCollectionIdIndexRoute,
  SettingsStateModelsIndexRoute: SettingsStateModelsIndexRoute,
  SettingsStateModelsIdEditRoute: SettingsStateModelsIdEditRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
